import { TestId } from "#/test-ids";

window.Sparkle ??= {};
window.Sparkle.LocationBrowser ??= {};
window.Sparkle.LocationBrowser.Views ??= {};

Sparkle.LocationBrowser.Views.SearchForm = class SearchForm extends Backbone.View {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.update = this.update.bind(this);
    this.initAutocomplete = this.initAutocomplete.bind(this);
    this.search = this.search.bind(this);
    this.render = this.render.bind(this);
    this.remove = this.remove.bind(this);
  }

  initialize(options = {}) {
    this.searchText = options.searchText || "";
    this.searchActive = options.searchActive || false;
    this.lat = options.lat;
    this.lng = options.lng;
    this.name = options.name;
    this.distance = options.distance || "";
    this.hidden = options.hidden || false;
    return (this.mapListener = null);
  }

  handleSubmit(e) {
    return e.preventDefault();
  }

  handleClear(e) {
    return Sparkle.LocationBrowser.instance.clearSearchParams();
  }

  handleInput(e) {
    return (this.searchText = e.target.value);
  }

  handleRangeChange(e) {
    return Sparkle.LocationBrowser.instance.setSearchParams({
      lat: this.lat,
      lng: this.lng,
      name: this.name,
      range: e.target.value,
    });
  }

  update(options = {}) {
    this.searchText = options.searchText != null ? options.searchText : this.searchText;
    this.searchActive = options.searchActive != null ? options.searchActive : this.searchActive;
    this.lat = options.lat;
    this.lng = options.lng;
    this.name = options.name;
    this.distance = options.distance != null ? options.distance : this.distance;
    this.hidden = options.hidden != null ? options.hidden : this.hidden;
    return this.render();
  }

  initAutocomplete() {
    const input = this.$el.find("input[name=location]")[0];
    if (!input) {
      return;
    }
    Sparkle.GoogleMaps.addAutoCompleteToField(input, this, {
      fields: ["name", "types", "geometry"],
      defaultOnEnter: true,
    });

    const self = this;
    return Sparkle.GoogleMaps.load(
      () => (self.mapListener = google.maps.event.addListener(self.autocomplete, "place_changed", self.search)),
    );
  }

  search() {
    const place = this.autocomplete.getPlace();
    place.types = place.types || [];
    const input = this.$el.find("input[name=location]")[0];

    if (place.types[0] === "administrative_area_level_1") {
      return Sparkle.LocationBrowser.instance.setSearchParams({
        state: place.name,
        name: place.name,
      });
    } else if (place.types[0] === "postal_code") {
      return Sparkle.LocationBrowser.instance.setSearchParams({
        zip: place.name,
        name: place.name,
      });
    } else if (place.geometry) {
      return Sparkle.LocationBrowser.instance.setSearchParams({
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
        name: input != null ? input.value : undefined,
        range: window.SparkleConfig.locationBrowser.searchRadiiMax,
      });
    }
  }

  render() {
    let className = "lb-search";
    if (this.hidden) {
      className += " hidden";
    }

    const showClear = this.searchActive;
    const showRange = this.searchActive && this.lat && this.lng;

    let rangeOptions = "";
    for (var miles of Array.from(window.SparkleConfig.locationBrowser.searchRadii)) {
      var selected =
        (this.distance != null ? this.distance.toString() : undefined) === miles.toString() ? "selected" : "";
      rangeOptions += `<option value='${miles}' ${selected}>${Sparkle.LocationBrowser.t(`miles_options.${miles}`)}</option>`;
    }
    rangeOptions += `<option value='' ${this.distance === "" ? "selected" : ""}>${Sparkle.LocationBrowser.t("unbounded_range")}</option>`;

    const clearButton = showClear
      ? `<span class='form-control clear' data-testid='${TestId.locationBrowser.searchClear}'>&times;</span>`
      : "";

    const rangeSelect = showRange
      ? `\
<label class="lb-range-select">
  <span>${Sparkle.LocationBrowser.t("range_label")}</span>
  <select name="range" data-testid="${TestId.locationBrowser.rangeSelect}">${rangeOptions}</select>
</label>\
`
      : "<label class='lb-range-select hidden'></label>";

    this.$el.attr("class", className);
    this.$el.html(`\
<label>
  <span>${Sparkle.LocationBrowser.t("place_label")}</span>
  <input type="text" name="location" data-testid="${TestId.locationBrowser.searchInput}" placeholder="${Sparkle.LocationBrowser.t("address_placeholder")}" value="${_.escape(this.searchText)}"/>
  ${clearButton}
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g fill="none" fill-rule="evenodd" stroke="#002147" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
      <path d="M18.373 9.846a5.946 5.946 0 0 1 0 8.491c-2.378 2.345-6.232 2.345-8.61 0a5.946 5.946 0 0 1 0-8.491c2.378-2.345 6.232-2.345 8.61 0zM23.99 23.877l-5.617-5.54"/>
    </g>
  </svg>
</label>
${rangeSelect}\
`);
    this.initAutocomplete();
    return this;
  }

  remove() {
    if (this.mapListener) {
      google.maps.event.removeListener(this.mapListener);
    }
    return super.remove(...arguments);
  }
};
Sparkle.LocationBrowser.Views.SearchForm.prototype.tagName = "form";
Sparkle.LocationBrowser.Views.SearchForm.prototype.className = "lb-search";

Sparkle.LocationBrowser.Views.SearchForm.prototype.events = {
  submit: "handleSubmit",
  "click .clear": "handleClear",
  "input input[name=location]": "handleInput",
  "change select[name=range]": "handleRangeChange",
};
